<template>
    <div class="home container-fluid py-2">
        <b-card class="mb-4">
            <b-form @submit.prevent="search" class="mb-3">
                <b-form-group label="Search:">
                    <b-form-input
                        v-model="filter.search"
                        placeholder="Search dealername username, awsAccountId, awsAccountName, awsPayerAccountName"
                    ></b-form-input>
                </b-form-group>
                <b-form-group label="Created from date:">
                    <b-form-datepicker
                        v-model="filter.from"
                        today-button
                        reset-button
                        close-button
                        value-as-date
                    ></b-form-datepicker>
                </b-form-group>
                <b-form-group label="Created to date:">
                    <b-form-datepicker
                        v-model="filter.to"
                        today-button
                        reset-button
                        close-button
                        value-as-date
                    ></b-form-datepicker>
                </b-form-group>
                <div class="d-flex align-items-center">
                    <b-button type="submit" class="mr-3 w-25" variant="primary">
                        Search
                    </b-button>
                </div>
            </b-form>
        </b-card>

        <b-button @click="onClickAdd" class="px-5 mb-3" variant="primary"
            >Add</b-button
        >
        <b-table :fields="fields" :items="items">
            <template #cell(action)="data">
                <b-button
                    @click="onClickEdit(data)"
                    class="mr-1 mb-1"
                    variant="primary"
                    >Edit</b-button
                >
            </template>
        </b-table>
        <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="perPage"
            @change="onChangePage"
        ></b-pagination>
        <DealerAddOrEditModal
            v-model="modalAddOrEdit"
            :current-data="currentData"
            @onDone="fetchData"
        ></DealerAddOrEditModal>
    </div>
</template>

<script>
import { getDealers } from '@/services/aws.service';
import * as moment from 'moment';
import DealerAddOrEditModal from '@/views/Modals/AddOrEditModal/DealerAddOrEditModal.vue';

export default {
    name: 'DealerView',
    components: { DealerAddOrEditModal },
    data() {
        return {
            modalDetail: false,
            modalAddOrEdit: false,
            modalInvoice: false,
            currentData: null,
            filter: {
                search: '',
                from: '',
                to: '',
                isActive: false,
                status: [],
            },
            items: [],
            perPage: 5,
            currentPage: 1,
            total: 0,
            fields: [
                {
                    key: 'dealername',
                    label: 'dealername',
                },
                {
                    key: 'accounts',
                    label: 'awsAccountIds',
                },
                {
                    key: 'action',
                    label: 'action',
                },
            ],
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            const query = {
                search: this.filter.search || undefined,
                from: this.filter.from
                    ? moment(this.filter.from).startOf('day').toISOString()
                    : undefined,
                to: this.filter.to
                    ? moment(this.filter.to).endOf('day').toISOString()
                    : undefined,
                status:
                    this.filter.status?.length > 0
                        ? this.filter.status.join(',')
                        : undefined,
                isActive: this.filter.isActive || undefined,
                page: this.currentPage,
                limit: this.perPage,
            };
            getDealers(query).then(({ data }) => {
                const { dealers, paginate } = data;
                console.log(dealers);
                dealers.forEach((dealer) => {
                    let accounts = [];
                    dealer.userAwsAccounts.forEach((userAwsAccount) => {
                        console.log(userAwsAccount);
                        accounts.push(userAwsAccount.awsAccountId);
                    });
                    dealer.accounts = accounts;
                });
                this.items = dealers;
                this.perPage = paginate.perPage;
                this.currentPage = paginate.currentPage;
                this.total = paginate.total;
            });
        },
        search() {
            this.fetchData();
        },
        onChangePage(val) {
            this.currentPage = val;
            this.fetchData();
        },
        onClickEdit(data) {
            this.currentData = data.item;
            this.modalAddOrEdit = true;
        },
        onClickInvoice(data) {
            this.currentData = data.item;
            this.modalInvoice = true;
        },
        onClickAdd() {
            this.currentData = null;
            this.modalAddOrEdit = true;
        },
        onClickDetail(data) {
            this.currentData = data.item;
            this.modalDetail = true;
        },
    },
};
</script>
